import { Component, OnDestroy, OnInit } from '@angular/core';
import { Actions, ofActionCompleted, Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { OffersQueries } from '../../queries/offers.queries';
import { OfferListQuery } from '../../interfaces/offer-list.query';
import { ActivatedRoute } from '@angular/router';
import { InventoryItemDataService } from '../../../sell-shared/services/inventory-item-data.service';
import {GetOfferHistory, LaunchDarklyService} from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import { OfferComponent } from '../offer/offer.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lib-offers-shell',
    templateUrl: './offers-shell.component.html',
    styleUrls: ['./offers-shell.component.scss'],
    imports: [TranslocoDirective, OfferComponent, CommonModule]
})
export class OffersShellComponent implements OnInit, OnDestroy {
  @Select(OffersQueries.offerList) vm$: Observable<OfferListQuery>;
  destroyed$ = new Subject();
  showBuyerUserNameToSeller = false;
  constructor(
    private analyticsService: AnalyticsService,
    private store: Store,
    private route: ActivatedRoute,
    private readonly inventoryItemDataService: InventoryItemDataService,
    private readonly _launchDarklyService: LaunchDarklyService
  ) {}

  ngOnInit() {
    this.inventoryItemDataService.fetchBasicDetails();
    this.showBuyerUserNameToSeller = this._launchDarklyService.getFeatureFlag('sell-buyerUserNameEnabled', false);
    setTimeout(() => {
      this.analyticsService.trackPageLoad({
        page: {
          pageName: `${this.analyticsService.digitalData.page.category.site}:Sell:Manage:Offers`,
          section: 'Sell',
          site: this.analyticsService.digitalData.page.category.site,
          subsection: 'Manage',
          title: 'Offers',
          data: {
            vehicleList: this.route.snapshot.parent ? this.route.snapshot.parent.paramMap.get('inventoryItemUuid') : ''
          }
        }
      });
    }, 200);
  }

  onGetHistory(offer) {
    this.store.dispatch(new GetOfferHistory(offer.offerUuid, offer.buyerOeUuid));
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
